import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { WEB_ROUTES } from '@portal-contract';
import { buttonVariants } from '@/lib/macondo';
import { useI18n } from '@/i18n/I18nProvider';
import { PageHeading } from '@/components/PageHeading';

/** `/signed-out`: confirmation after logout. */
export function SignedOutScreen() {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex w-full max-w-[440px] flex-col items-start gap-400 pt-400" data-screen="SignedOutScreen">
      <LogOut size={28} aria-hidden="true" className="text-typography-secondary" />
      <PageHeading>{t('signedOut.heading')}</PageHeading>
      <Link to={WEB_ROUTES.login} replace className={`${buttonVariants({ size: 'lg' })} text-callout-medium min-h-[48px]`}>
        {t('signedOut.again')}
      </Link>
    </div>
  );
}
